<div class="d-flex align-items-center" [ngClass]="toggleValue ? 'justify-content-between' : 'justify-content-end'">

  @if (selectedBackUp !== '') {
    <efx-badge class="me-3" type="info" [showIcon]="true" customIcon="account_box">
      {{selectedBackUp}}
    </efx-badge>
  }
  @if (btnVisible) {
    <button
      class="efx-button-secondary me-3"
      [disabled]="disabledHistorial"
      (click)="handleShowModal()"
      >
      <span class="material-symbols-outlined me-2">
        history
      </span>
      Historial
    </button>
  }


  <app-modal-history [showModal]="showModal" [dataHistorialModal]="dataHistorialModal"
    (historySelect)="selectHistory($event)" (closeModal)="closeModal($event)">
  </app-modal-history>

</div>